import { useEffect } from 'react';
import { useAudioStore } from '@/stores/audio.store';

export function AudioUnlockProvider(): null {
  const setAudioUnlocked = useAudioStore((s) => s.setAudioUnlocked);

  useEffect(() => {
    const handleUserInteraction = () => {
      setAudioUnlocked(true);
      // Remove listeners after first interaction
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
      document.removeEventListener('touchstart', handleUserInteraction);
    };

    document.addEventListener('click', handleUserInteraction);
    document.addEventListener('keydown', handleUserInteraction);
    document.addEventListener('touchstart', handleUserInteraction);

    return () => {
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
      document.removeEventListener('touchstart', handleUserInteraction);
    };
  }, [setAudioUnlocked]);

  return null;
}
